import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

const getBlock = (children) => ({
  name: children.name,
  className: 'feature12-block',
  md: 8,
  xs: 24,
  children: {
    icon: {
      className: 'feature12-icon',
      children: children.icon,
    },
    textWrapper: {
      className: 'feature12-text',
    },
    title: {
      className: 'feature12-title',
      children: children.title,
    },
    content: {
      className: 'feature12-content',
      children: children.content,
    },
  },
});

const getBlockImg = (data) => ({
  name: data.name,
  className: 'img',
  md: 8,
  xs: 24,
  children: {
    wrapper: {
      className: 'img-content',
    },
    img: {
      children: data.img,
    },
  },
});

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature12-wrapper',
    },
    page: {
      className: 'home-page feature12',
    },
    OverPack: {
      playScale: 0.3,
    },
    bg: {
      className: 'bg',
      children: 'https://imm.86links.com/assets/landing/feature/feature12-bg.png',
    },
    fixedRight: {
      className: 'fixed-right',
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: '战略新兴产业',
          className: 'title-h1',
        },
      ],
    },
    block: {
      className: 'feature12-block-wrapper',
      children: [
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature12-img/icon-1.png',
          title: '高端装备制造产业',
          content: '坚持以发展工业机器人、军民融合为重点，以机器人及高档数控机床、智能关键基础零部件、智能测控装置为重要领域，加速打造集群经济。',
          name: 'block0',
        }),
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature12-img/icon-2.png',
          title: '电子信息产业',
          content: '打造以物联网、传感器等成长性关联领域，融合新一代信息技术电子产业集群。',
          name: 'block1',
        }),
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature12-img/icon-3.png',
          title: '新材料产业',
          content: '聚集各类新材料领域的行业领先企业，建设具有全国影响力的特色新材料产业创新基地。',
          name: 'block2',
        }),
      ],
    },
    img: {
      className: 'img-wrapper',
      children: [
        getBlockImg(
          {
            name: 'block0',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-1.png',
          }
        ),
        getBlockImg(
          {
            name: 'block1',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-2.png',
          }
        ),
        getBlockImg(
          {
            name: 'block2',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-3.png',
          }
        ),
      ],
    },
  },
};
